export default {
  tabs: {
    accounts: "Konten",
    report_config: "Berichtskonfiguration",
    general: "Allgemein",
    billing_notifications: "Abrechnung und Benachrichtigungen",
    privacy: "Datenschutz",
    help: "Hilfe",
    about: "Über uns",
  },
  general: {
    title: "Allgemeine Einstellungen",
    displaySettings: "Anzeigeeinstellungen",
    theme: "Design",
    primaryColor: "Primärfarbe",
    languageSettings: "Spracheinstellungen",
    language: "Sprache",
    otherSettings: "Weitere Einstellungen",
    timezone: "Zeitzone",
    selectTimezone: "Zeitzone auswählen",
    dateFormat: "Datumsformat",
    selectDateFormat: "Datumsformat auswählen",
    numberFormat: "Zahlenformat",
    selectNumberFormat: "Zahlenformat auswählen",
    englishFormat: "Englisches Format",
    europeanFormat: "Europäisches Format",
    spaceFormat: "Format mit Leerzeichen",
  },
  account: {
    title: "Kontoeinstellungen",
    subtitle:
      "Verwalten Sie Ihre persönlichen Informationen, Sicherheitseinstellungen und Kontopräferenzen",
    edit: "Bearbeiten",
    save: "Änderungen speichern",
    cancel: "Abbrechen",
    profile: {
      title: "Persönliche Informationen",
      name: "Name",
      email: "E-Mail-Adresse",
      email_tip: "Die E-Mail-Adresse kann nicht geändert werden",
      company: "Unternehmen",
      phone: "Telefon",
      phone_invalid: "Das Telefonnummernformat ist ungültig",
      bio: "Biografie",
      website: "Website",
      website_invalid: "Das Website-URL-Format ist ungültig",
      location: "Standort",
      position: "Position",
      validation_error: "Formularvalidierung fehlgeschlagen, bitte überprüfen Sie Ihre Eingaben",
      change_avatar: "Avatar ändern",
      remove: "Avatar entfernen",
      save_success: "Profil erfolgreich aktualisiert",
      avatar_format_error: "Sie können nur JPG/PNG-Dateien hochladen!",
      avatar_size_error: "Das Bild muss kleiner als 2 MB sein!",
      avatar_upload_error: "Avatar-Upload fehlgeschlagen",
      avatar_format_tip: "JPG/PNG-Format",
      avatar_size_tip: "Maximale Dateigröße: 2 MB",
      name_placeholder: "Geben Sie Ihren Namen ein",
      company_placeholder: "Geben Sie Ihr Unternehmen ein",
      phone_placeholder: "Geben Sie Ihre Telefonnummer ein",
      bio_placeholder: "Erzählen Sie uns etwas über sich",
      website_placeholder: "https://beispiel.com",
      location_placeholder: "Geben Sie Ihren Standort ein",
      position_placeholder: "Geben Sie Ihre Position ein",
    },
    security: {
      password_title: "Passworteinstellungen",
      password_tip: "Zum Schutz Ihres Kontos wird empfohlen, Ihr Passwort regelmäßig zu ändern",
      change_password: "Passwort ändern",
      current_password: "Aktuelles Passwort",
      new_password: "Neues Passwort",
      confirm_password: "Neues Passwort bestätigen",
      save_password: "Passwort speichern",
      password_changed: "Passwort aktualisiert",
      password_mismatch: "Das neue Passwort und die Bestätigung stimmen nicht überein",
      password_incorrect: "Das aktuelle Passwort ist falsch",
      password_required: "Bitte füllen Sie alle Passwortfelder aus",
      password_too_short: "Das Passwort muss mindestens 8 Zeichen lang sein",
      password_change_failed: "Passwortänderung fehlgeschlagen",
      two_factor_auth_title: "Zwei-Faktor-Authentifizierung",
      two_factor_auth: "Zwei-Faktor-Authentifizierung",
      two_factor_auth_desc:
        "Fügen Sie eine zusätzliche Sicherheitsebene hinzu, die sowohl Ihr Passwort als auch einen Verifizierungscode vom Gerät erfordert, um sich anzumelden",
      two_factor_auth_coming_soon: "Demnächst verfügbar",
      current_password_placeholder: "Aktuelles Passwort eingeben",
      new_password_placeholder: "Neues Passwort eingeben",
      confirm_password_placeholder: "Neues Passwort bestätigen",
    },
    login_activity: {
      title: "Anmeldeaktivität",
      manage: "Verwalten",
      trust_device: "Gerät vertrauen",
      logout_device: "Gerät abmelden",
      device_trusted: "Gerät {location} wurde genehmigt",
      device_logged_out: "Vom Gerät {location} abgemeldet",
      showing_details: "Details für {location} anzeigen - IP: {ip}, Zeit: {time}",
      manage_info: "Anmeldeaktivität für {location} verwalten",
      login_details: "Anmeldedetails",
      ip_address: "IP-Adresse",
      time: "Zeit",
      isp: "Internetdienstanbieter",
      bot_score: "Bot-Score",
      locations: {
        current: "Aktuelles Gerät",
      },
      suspicious: "Verdächtig",
      mobile_device: "Mobiles Gerät",
      api_client: "API-Client",
      trusted: "Vertrauenswürdig",
      device: "Gerät",
      client: "Client",
      unknown: "Unbekannt",
      risk_reasons: "Risikogründe",
      location: "Standort",
      trust_failed: "Gerätegenehmigung fehlgeschlagen",
      show_more: "{0} weitere anzeigen",
      show_less: "Weniger anzeigen",
    },
    danger: {
      title: "Gefahrenzone",
      delete_title: "Konto löschen",
      delete_desc:
        "Löschen Sie Ihr Konto und alle zugehörigen Daten dauerhaft. Diese Aktion kann nicht rückgängig gemacht werden.",
      confirm_title: "Sind Sie sicher, dass Sie Ihr Konto löschen möchten?",
      confirm_desc:
        "Diese Aktion löscht Ihr Konto und alle zugehörigen Daten dauerhaft. Sie kann nicht rückgängig gemacht werden.",
      confirm_email_tip: "Um die Löschung zu bestätigen, geben Sie bitte Ihre E-Mail-Adresse ein:",
      confirm_email_placeholder: "Geben Sie Ihre E-Mail-Adresse ein",
      confirm: "Löschung bestätigen",
      cancel: "Abbrechen",
      delete_account: "Konto löschen",
      delete_success: "Konto erfolgreich gelöscht",
      email_mismatch:
        "Die E-Mail-Adresse stimmt nicht überein. Bitte geben Sie die korrekte E-Mail-Adresse ein.",
    },
  },
  privacy: {
    title: "Datenschutzeinstellungen",
    privacyPolicyAgreement: "Datenschutzrichtlinienvereinbarung",
    privacyPolicyAgreementDesc:
      "Sie haben bei der Registrierung eines Kontos unserer Datenschutzrichtlinie zugestimmt",
    privacyPolicyAgreementInfo:
      "Die Datenschutzrichtlinienvereinbarung kann nicht widerrufen werden",
  },
  reportConfig: {
    colorPicker: {
      title: "Farbauswahl",
    },
    currencyName: {
      EUR: "Euro (€)",
      USD: "US-Dollar ($)",
      GBP: "Britisches Pfund (£)",
    },
    fetchDataFailed: "Daten konnten nicht abgerufen werden",
    configSelection: "Konfigurationsauswahl",
    default: "Standard",
    professional: "Professionell",
    simple: "Einfach",
    custom: "Benutzerdefiniert",
    exportType: "Exporttyp",
    upgradeToUnlock: "Upgrade durchführen, um diese Funktion freizuschalten",
    commonSettings: "Allgemeine Einstellungen",
    tableHeaderFont: "Tabellenkopf-Schriftart",
    tableCellFont: "Tabellenzellen-Schriftart",
    textFont: "Textschriftart",
    textColor: "Textfarbe",
    tableHeaderBg: "Tabellenkopf-Hintergrund",
    selectColor: "Farbe auswählen",
    dataFormat: "Datenformat",
    selectFormat: "Format auswählen",
    titleFontSize: "Titel-Schriftgröße",
    watermarkFontSize: "Wasserzeichen-Schriftgröße",
    titleColor: "Titelfarbe",
    premiumTitleColorActive: "Premium-Titelfarbe ist aktiv",
    blue: "Blau",
    red: "Rot",
    displayFields: "Anzuzeigende Felder",
    showDate: "Datum anzeigen",
    showContact: "Kontakt anzeigen",
    showEmail: "E-Mail anzeigen",
    showTitle: "Titel anzeigen",
    showEmissionDetails: "Emissionsdetails anzeigen",
    showSummary: "Zusammenfassung anzeigen",
    showTotalDistance: "Gesamtstrecke anzeigen",
    showProductionEmission: "Produktions-Emission anzeigen",
    showTransportEmission: "Transport-Emission anzeigen",
    showTotalEmission: "Gesamt-Emission anzeigen",
    showTax: "Steuer anzeigen",
    showCompliance: "Compliance-Erklärung anzeigen",
    privacyFields: "Datenschutzfelder",
    hideCompanyName: "Unternehmensname ausblenden",
    hideContact: "Kontakt ausblenden",
    hideEmail: "E-Mail ausblenden",
    hideLogo: "Unternehmenslogo ausblenden",
    hideWeight: "Gewicht ausblenden",
    premiumFeatures: "Premium-Funktionen",
    generalConfig: "Allgemeine Konfiguration",
    language: "Sprache",
    selectLanguage: "Sprache auswählen",
    currency: "Währung",
    selectCurrency: "Währungseinheit auswählen",
    showLogo: "Logo anzeigen",
    companyLogo: "Unternehmenslogo",
    logoSupportFormat: "Unterstützte Formate: JPG, PNG, GIF, WEBP, Max. 2 MB",
    showCompany: "Unternehmen anzeigen",
    companyName: "Unternehmensname",
    enterCompanyName: "Unternehmensname eingeben",
    customContact: "Benutzerdefinierter Kontakt",
    enterContact: "Kontakt eingeben",
    customEmail: "Benutzerdefinierte E-Mail",
    enterEmail: "E-Mail eingeben",
    customCompliance: "Benutzerdefinierte Compliance-Erklärung",
    enterCompliance: "Compliance-Erklärung eingeben",
    customFooter: "Benutzerdefinierte Fußzeile",
    excelFontStyle: "Der Schriftstil in Excel wird durch die Standardeinstellungen gesteuert",
    footerPlaceholder: "z.B. CBAM-Konformitätsbericht TaxEcoBit",
    showEmissionChart: "Emissionsdiagramm anzeigen",
    pdfAdvancedFeatures: "Erweiterte PDF-Funktionen",
    removeWatermark: "Wasserzeichen entfernen",
    showSignatureArea: "Signaturbereich anzeigen",
    removeQRCode: "QR-Code entfernen",
    logoPosition: "Logoposition",
    selectPosition: "Position auswählen",
    topLeft: "Oben links",
    topRight: "Oben rechts",
    borderStyle: "Rahmenstil",
    none: "Keiner",
    solid: "Durchgehend",
    premiumTitleColor: "Premium-Titelfarbe",
    customTableHeaderBg: "Benutzerdefinierter Tabellenkopf-Hintergrund",
    customWatermark: "Benutzerdefiniertes Wasserzeichen",
    enterWatermark: "Wasserzeicheninhalt eingeben",
    inviteText: "Einladungstext",
    enterInviteText: "Einladungstext eingeben",
    excelAdvancedFeatures: "Erweiterte Excel-Funktionen",
    columnWidth: "Spaltenbreite",
    cellBackground: "Zellenhintergrund",
    mergeHeader: "Kopfzeile zusammenführen",
    enableFilter: "Filter aktivieren",
    addDigitalSignature: "Digitale Signatur hinzufügen",
    signatureContent: "Signaturinhalt",
    enterSignature: "Signaturinhalt eingeben",
    premiumFeaturesDesc:
      "Diese Premium-Funktionen können die Professionalität Ihrer Berichte verbessern",
    upgradeMessage:
      "Führen Sie ein Upgrade auf Premium durch, um die Sprachänderung, benutzerdefiniertes Logo und andere exklusive Funktionen freizuschalten",
    lightGray: "Hellgrau",
    darkGray: "Dunkelgrau",
    messages: {
      excelExportRequiresPro: "Excel-Export erfordert ein Pro-Abonnement, auf PDF umgeschaltet",
      logoUploadFailed: "Logo-Upload fehlgeschlagen",
      configSaveSuccess: "Konfiguration erfolgreich gespeichert",
      configSaveFailed: "Speichern der Konfiguration fehlgeschlagen",
      imageFileOnly: "Nur Bilddateien werden unterstützt!",
      imageSizeLimit: "Die Bildgröße darf 2 MB nicht überschreiten!",
      fileReadFailed: "Datei konnte nicht gelesen werden",
    },
  },
  billing: {
    title: "Abrechnung und Benachrichtigungen",
    compliance: "Compliance erforderlich",
    compliance_desc: "Kritische Benachrichtigungen, können nicht deaktiviert werden",
    service: "Kritischer Service",
    service_desc: "Empfohlen aktiviert zu lassen",
    experience: "Benutzererfahrung",
    experience_desc: "Optional, kann deaktiviert werden",
  },
  notification: {
    title: "Benachrichtigungseinstellungen",
    policy: "CBAM-Richtlinienaktualisierungen",
    policy_desc:
      "Erhalten Sie dringende Änderungen der EU-CBAM-Vorschriften. Erforderlich für Compliance und Vermeidung von Strafen.",
    payment: "Zahlungsfehler-Warnungen",
    payment_desc:
      "Sofort informiert werden, wenn die Zahlung fehlschlägt, um eine Dienstunterbrechung zu vermeiden.",
    expiry: "Planablauf-Erinnerungen",
    expiry_desc:
      "3 Tage vor Ablauf Ihres Plans informiert werden. Pünktlich erneuern, um eine Dienstpause zu vermeiden.",
    quota: "Kontingentwarnungen",
    quota_desc:
      "Warnung bei Verbrauch von 80 % der monatlichen Berechnungen. Unerwartete Begrenzungen vermeiden.",
    ticket: "Support-Ticket-Updates",
    ticket_desc:
      "E-Mail-Benachrichtigungen erhalten, wenn sich der Status Ihres Support-Tickets ändert.",
    referral: "Empfehlungsbelohnungen",
    referral_desc:
      "Informiert werden, wenn Sie durch erfolgreiche Empfehlungen kostenlose Berechnungen erhalten.",
  },
  info: {
    about_taxecobit: "Über TaxEcoBit",
    about_taxecobit_description:
      "TaxEcoBit ist ein spezialisiertes Tool für EU-KMU, um CBAM-Kohlenstoffemissionsberichte zu rationalisieren und die Compliance zu vereinfachen. Mit einer Genauigkeit von über 90 % ermöglicht es schnelle Berechnungen und Berichtsgenerierung und hilft dabei, das Risiko von Strafen (1.000 € bis 10.000 €) zu mindern.",
    our_vision: "Unsere Vision",
    our_vision_description:
      "Wir zielen darauf ab, EU-KMU mit nahtloser CBAM-Compliance zu stärken, nachhaltiges Wachstum zu fördern und die Nachhaltigkeitsziele von 2026 durch innovative Lösungen zu unterstützen.",
    contact_us: "Kontaktieren Sie uns",
    follow_us: "Folgen Sie uns:",
    version_info: "Versionsinformationen",
    version: "Version",
    last_updated: "Zuletzt aktualisiert",
    license: "Lizenz",
    copyright: "© 2025 TaxEcoBit. Alle Rechte vorbehalten.",
  },
};
